import { useEffect, useRef, useState } from 'react';

const useScrollAnimation = (options = {}) => {
  const elementRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // 要素が画面に入ったら表示
        if (entry.isIntersecting) {
          setIsVisible(true);
          // 一度表示したら監視を停止（再度非表示にしない）
          observer.unobserve(element);
        }
      },
      {
        threshold: options.threshold || 0.1, // 10%見えたら発火
        rootMargin: options.rootMargin || '0px',
      }
    );

    observer.observe(element);

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [options.threshold, options.rootMargin]);

  return [elementRef, isVisible];
};

export default useScrollAnimation;